module.exports = __webpack_public_path__ + "img/ywbk11.dee3333f.jpg";